import React from 'react';
import Icon from '../common/Icons';
import { getCareModeMeta } from './siteListUtils';
import './SiteCareModeBadge.css';

export default function SiteCareModeBadge({
  mode,
  variant = 'default',
  className = '',
  showIcon = true
}) {
  const meta = getCareModeMeta(mode);
  if (!meta) {
    return <span className={`st-care-badge st-care-badge--unknown ${className}`.trim()}>—</span>;
  }

  return (
    <span
      className={`st-care-badge st-care-badge--${meta.variant} st-care-badge--${variant} ${className}`.trim()}
      title={meta.label}
    >
      {showIcon ? (
        <Icon name={meta.icon} size={variant === 'compact' ? 12 : 14} aria-hidden />
      ) : null}
      <span>{variant === 'compact' ? meta.shortLabel : meta.label}</span>
    </span>
  );
}
